import { Component, OnInit } from '@angular/core';
import {UserService} from '../../services/user.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastService} from '../../services/toast.service';
import {ModalController} from '@ionic/angular/lazy';
import {CustomValidators} from '../../core/helper/validators';

@Component({
  standalone: false,
  selector: 'app-email-change',
  templateUrl: './email-change.component.html',
  styleUrls: ['./email-change.component.scss'],
})
export class EmailChangeComponent implements OnInit {

  emailChangeForm: FormGroup;

  constructor(private userService: UserService,
              public formBuilder: FormBuilder,
              private toast: ToastService,
              private modal: ModalController) {

    this.emailChangeForm = this.formBuilder.group({
      new_email: ['', [Validators.required, Validators.email]],
      current_password: ['', [Validators.minLength(8)]],
    }, {});

  }

  ngOnInit() {}

  cancel() {
    this.modal.dismiss(null, 'cancel');
  }

  onChangeEmail() {

    this.userService.setEmail(this.emailChangeForm.value.current_password, this.emailChangeForm.value.new_email).subscribe(
      x => {
        this.toast.presentToast('Email Adresse geändert', 'success')
        this.modal.dismiss({});
      }, error => {
        this.toast.readAnyErrorValues(error);
      });
  }
}
